module.exports = __webpack_public_path__ + "static/media/email.1a1d4ce8.svg";